import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { Chart, registerables } from 'chart.js';

import html2canvas from 'html2canvas';
import * as html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss'],
})
export class DashboardsComponent extends BaseCtl {
  @ViewChild('content', { static: false }) content!: ElementRef;

  private orgId: number = 0;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super('', locator, route);
    let _self = this;
    locator.config.getProperty('endpoint.auth').then((property: string) => {
      _self.initApiEndpoint(property);
    });
  }

  override ngOnInit(): void {
    let _self = this;
    this.locator.config
      .getProperty('endpoint.auth')
      .then((property: string) => {
        _self.getAppStorageSizeInfo(function () {
          _self.getAppSizeInfo();
        });
      });
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.key = data.key;
    form.value = data.value;
    form.createdBy = data.createdBy;
    form.createdDatetime = data.createdDatetime;
    form.modifiedBy = data.modifiedBy;
    form.modifiedDatetime = data.modifiedDatetime;
    form.expiredAuthKey = data.expiredAuthKey;
    form.startDate = data.startDate;
    form.endDate = data.endDate;
  }

  public appInfoList: any | null = null;
  public getAppSizeInfo() {
    //alert('call app info');
    let _self = this;
    this.locator.config
      .getProperty('endpoint.dashboard')
      .then((property: string) => {
        let url = property + '/info';
        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.appInfoList = res.result['data'];
        });
      });
  }

  public appStorageInfoList: any | null = null;

  public getAppStorageSizeInfo(callback: any) {
    //alert('call app info');
    let _self = this;
    this.locator.config
      .getProperty('endpoint.dashboard')
      .then((property: string) => {
        let url = property + '/storageinfo';
        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.appStorageInfoList = res.result['data'];

          if (callback) {
            callback();
          }
        });
      });
  }

  ngAfterViewInit() {
    // Force Angular to detect all changes and ensure content is loaded
    this.cdr.detectChanges();
  }

  /**
   * Download PDF HTML
   */
  downloadPDF() {
    // Options for PDF generation
    const element = this.content.nativeElement;

    const options = {
      margin: 0.5,
      filename: 'document_with_image.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' },
    };

    // Wait for any dynamically loaded content (like images) to be fully loaded
    console.log(element);

    setTimeout(() => {
      html2pdf().from(element).set(options).save();
    }, 1000); // Adjust the delay if necessary
  }

  public captureScreen() {
    let downLoadSection = document.getElementById('pdfmake') as HTMLElement;

    // Use html2canvas to capture the DOM element
    html2canvas(downLoadSection, { scale: 2 }).then(function (canvas) {
      let HTML_Width = canvas.width;
      let HTML_Height = canvas.height;

      let top_left_margin = 15;
      let PDF_Width = 595.28; // A4 width in points
      let PDF_Height = 841.89; // A4 height in points
      let canvas_image_width = PDF_Width - top_left_margin * 2; // Adjust for margins
      let canvas_image_height = (HTML_Height / HTML_Width) * canvas_image_width;

      let totalPDFPages = Math.ceil(canvas_image_height / PDF_Height);

      // Convert canvas to image
      let imgData = canvas.toDataURL('image/png', 0.8);

      // Create a new jsPDF instance
      let pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);

      // Load and add the header image
      const headerImage = new Image();
      headerImage.src = 'assets/images/cdblack.png'; // Path to the header image
      headerImage.onload = function () {
        // Loop through pages to create multi-page PDF
        for (let i = 0; i < totalPDFPages; i++) {
          let yOffset = -(PDF_Height * i);

          if (i !== 0) {
            pdf.addPage();
          }

          // Add header image at the top
          pdf.addImage(headerImage, 'PNG', 15, 10, 150, 75); // Larger header image dimensions

          // Add content image (captured DOM)
          pdf.addImage(
            imgData,
            'PNG',
            top_left_margin,
            80 + yOffset, // Position content below the larger header
            canvas_image_width,
            canvas_image_height,
          );

          // Add right-aligned footer text
          const pageHeight = pdf.internal.pageSize.height; // Height of the page
          const footerText = 'Powered by NCSIndore';
          pdf.setFontSize(10); // Set font size explicitly
          const fontSize = 10; // Font size used
          const textWidth =
            (pdf.getStringUnitWidth(footerText) * fontSize) /
            pdf.internal.scaleFactor;
          pdf.text(
            footerText, // Footer text
            PDF_Width - textWidth - top_left_margin, // Align text to the right
            pageHeight - 10, // Position footer 10 units from the bottom
          );
        }

        // Save the PDF
        pdf.save('NCSIndore.pdf');
      };
    });
  }
}
